import defaultWindowLevelPresets from '../components/WindowLevelActionMenu/defaultWindowLevelPresets';

export default {
  'cornerstone.windowLevelPresets': defaultWindowLevelPresets,
};
